import { FormattedMessage } from "react-intl";
import DocumentIcon from "@/common/svg/document-icon.svg";
import PersonIcon from "@/common/svg/person-checked.svg";
import WalletIcon from "@/common/svg/wallet-checked.svg";

export const content = [
  {
    order: "01",
    Icon: DocumentIcon,
    title: <FormattedMessage defaultMessage="Зарегистрируйтесь" />,
    description: (
      <FormattedMessage defaultMessage="ИИН, телефон, email, биометрия и согласия (OTP)" />
    ),
  },
  {
    order: "02",
    Icon: PersonIcon,
    title: <FormattedMessage defaultMessage="Пройдите проверки" />,
    description: (
      <FormattedMessage defaultMessage="Госбазы и КБ: договор, доходы, стаж, реестры" />
    ),
  },
  {
    order: "03",
    Icon: WalletIcon,
    title: <FormattedMessage defaultMessage="Получите финансирование" />,
    description: (
      <FormattedMessage defaultMessage="Подписание облачной ЭЦП + уведомление работодателю" />
    ),
  },
];
